function iconPosition(){
	var $icon = $('.sidebar-nav__link img'),
			$maxWidth = 0,
			$temp;

	$icon.each(function(){
		var $this = $(this),
				$iconWidth = $this.width();

		if ($iconWidth > $maxWidth) {
			$maxWidth = $iconWidth;
		}
	})
	
	$icon.each(function(){
		var $this = $(this),
				$iconWidth = $this.width();

		if ($iconWidth <= $maxWidth) {
			$temp = ($maxWidth - $iconWidth)/2;

			if ($(window).outerWidth() > 1499) {
				$this.css('left', 69 + $temp + 'px');

			}else if ($(window).outerWidth() <= 1499 && $(window).outerWidth() > 1199) {
				$this.css('left', 37 + $temp + 'px');

			}else if ($(window).outerWidth() <= 1199 && $(window).outerWidth() > 991) {
				$this.css('left', 11 + $temp + 'px');

			}else if ($(window).outerWidth() <= 991 && $(window).outerWidth() > 576) {
				$this.css('left', 15 + $temp + 'px');

			}
		}
	})
}

$(function(){
	iconPosition();
})

$(window).resize(function(){
	iconPosition();
})